import store from "../../Redux/store";
import { setSDG, countSDG } from "./SDG.reducer";

export function saveListSDG(records) {
  store.dispatch(setSDG(records));
}

export function saveCountSDG(count) {
  store.dispatch(countSDG(count));
}
